// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"51e8551f","112":"aa10d9f2","207":"514ee8cc","228":"793e2a6e","360":"6aec5f9b","453":"39edb0bf","669":"8e55bbe6","690":"3df6130b","739":"7a7b836c"}[chunkId] + ".chunk.js";
};